import { FC } from 'react';
import { SelectContentEditorModal } from './SelectContentEditorModal';
import { SelectContentTemplateModal } from './SelectContentTemplateModal';
import {
  SelectContentEditorProvider,
  useSelectContentEditorContext,
  SelectedContentEditorStep,
} from './contexts';

const withContext = (Component: FC<unknown>) => () => (
  <SelectContentEditorProvider>
    <Component />
  </SelectContentEditorProvider>
);

export const SelectContentEditorModals = withContext(() => {
  const { selectedContentEditorStep } = useSelectContentEditorContext();

  switch (selectedContentEditorStep) {
    case SelectedContentEditorStep.SelectEditor:
      return <SelectContentEditorModal />;

    case SelectedContentEditorStep.SelectDragAndDropDefaultTemplate:
      return <SelectContentTemplateModal />;

    default:
      return null;
  }
});
